import {importFile, MainRequest} from 'Services/common';
import {download} from 'Utils/common';

export interface DictListItem {
    id: string;
    childNumber: string;
    children?: DictListItem[];
    code: string;
    createTime: string;
    deleteStatus: string;
    name: string;
    nameEn: string;
    parentId?: string;
    status: '0' | '1';
    updateTime: string;
    remark: string;
    key?: number;
}

/**
 * 数据字典维度列表
 */
export function getDictList() {
    return MainRequest.post<SuccessData<DictListItem[]>>('/dict/listRoot')
        .then(res => {
            return res.data.data;
        })
        .then(data => data.map(item => ({...item, key: Math.random()})));
}

export function getDictNode(code: string): Promise<DictListItem[]> {
    return MainRequest.post<SuccessData<DictListItem[]>>(
        '/dict/getByParentCode',
        {code},
    )
        .then(res => res.data.data)
        .then(data => data.map(item => ({...item, children: undefined})));
}

export interface DictForm {
    id?: string;
    parentId?: string;
    code: string;
    name: string;
    nameEn: string;
    remark: string;
    status: '0' | '1';
}

/**
 * 数据字典保存
 * @param data
 */
export function saveDict(data: DictForm) {
    return MainRequest.post('/dict/save', {
        ...data,
        parentId: data.parentId || '0',
    });
}

/**
 * 删除字典
 * @param id
 */
export function deleteDict(id: string) {
    return MainRequest.post('/dict/delete', {id});
}

/**
 * 数据字典启用停用
 * @param id
 * @param status
 */
export function changeStatus(id: string, status: '0' | '1') {
    return MainRequest.post('/dict/changeStatus', {id, status});
}

/**
 * 数据字典下移
 */
export function nodeMoveDown(id: string) {
    return MainRequest.post('/dict/nodeMoveDown', {id});
}

/**
 * 导入维度
 * @param file
 */
export function importDict(file: File) {
    return importFile('/dict/importExcel', file);
}

/**
 * 导出维度
 */
export function exportDict() {
    return download('/dict/exportExcel', {method: 'POST'});
}
